
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eByBq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa1f5cc61f06db5d$export$2e2bcd8739ae039; });
// packages/alpinejs/src/scheduler.js
var $aa1f5cc61f06db5d$var$flushPending = false;
var $aa1f5cc61f06db5d$var$flushing = false;
var $aa1f5cc61f06db5d$var$queue = [];
var $aa1f5cc61f06db5d$var$lastFlushedIndex = -1;
function $aa1f5cc61f06db5d$var$scheduler(callback) {
    $aa1f5cc61f06db5d$var$queueJob(callback);
}
function $aa1f5cc61f06db5d$var$queueJob(job) {
    if (!$aa1f5cc61f06db5d$var$queue.includes(job)) $aa1f5cc61f06db5d$var$queue.push(job);
    $aa1f5cc61f06db5d$var$queueFlush();
}
function $aa1f5cc61f06db5d$var$dequeueJob(job) {
    let index = $aa1f5cc61f06db5d$var$queue.indexOf(job);
    if (index !== -1 && index > $aa1f5cc61f06db5d$var$lastFlushedIndex) $aa1f5cc61f06db5d$var$queue.splice(index, 1);
}
function $aa1f5cc61f06db5d$var$queueFlush() {
    if (!$aa1f5cc61f06db5d$var$flushing && !$aa1f5cc61f06db5d$var$flushPending) {
        $aa1f5cc61f06db5d$var$flushPending = true;
        queueMicrotask($aa1f5cc61f06db5d$var$flushJobs);
    }
}
function $aa1f5cc61f06db5d$var$flushJobs() {
    $aa1f5cc61f06db5d$var$flushPending = false;
    $aa1f5cc61f06db5d$var$flushing = true;
    for(let i = 0; i < $aa1f5cc61f06db5d$var$queue.length; i++){
        $aa1f5cc61f06db5d$var$queue[i]();
        $aa1f5cc61f06db5d$var$lastFlushedIndex = i;
    }
    $aa1f5cc61f06db5d$var$queue.length = 0;
    $aa1f5cc61f06db5d$var$lastFlushedIndex = -1;
    $aa1f5cc61f06db5d$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $aa1f5cc61f06db5d$var$reactive;
var $aa1f5cc61f06db5d$var$effect;
var $aa1f5cc61f06db5d$var$release;
var $aa1f5cc61f06db5d$var$raw;
var $aa1f5cc61f06db5d$var$shouldSchedule = true;
function $aa1f5cc61f06db5d$var$disableEffectScheduling(callback) {
    $aa1f5cc61f06db5d$var$shouldSchedule = false;
    callback();
    $aa1f5cc61f06db5d$var$shouldSchedule = true;
}
function $aa1f5cc61f06db5d$var$setReactivityEngine(engine) {
    $aa1f5cc61f06db5d$var$reactive = engine.reactive;
    $aa1f5cc61f06db5d$var$release = engine.release;
    $aa1f5cc61f06db5d$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($aa1f5cc61f06db5d$var$shouldSchedule) $aa1f5cc61f06db5d$var$scheduler(task);
                else task();
            }
        });
    $aa1f5cc61f06db5d$var$raw = engine.raw;
}
function $aa1f5cc61f06db5d$var$overrideEffect(override) {
    $aa1f5cc61f06db5d$var$effect = override;
}
function $aa1f5cc61f06db5d$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $aa1f5cc61f06db5d$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $aa1f5cc61f06db5d$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $aa1f5cc61f06db5d$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $aa1f5cc61f06db5d$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$aa1f5cc61f06db5d$var$release(effectReference);
}
// packages/alpinejs/src/utils/dispatch.js
function $aa1f5cc61f06db5d$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $aa1f5cc61f06db5d$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$aa1f5cc61f06db5d$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $aa1f5cc61f06db5d$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $aa1f5cc61f06db5d$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $aa1f5cc61f06db5d$var$started = false;
function $aa1f5cc61f06db5d$var$start() {
    if ($aa1f5cc61f06db5d$var$started) $aa1f5cc61f06db5d$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $aa1f5cc61f06db5d$var$started = true;
    if (!document.body) $aa1f5cc61f06db5d$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $aa1f5cc61f06db5d$var$dispatch(document, "alpine:init");
    $aa1f5cc61f06db5d$var$dispatch(document, "alpine:initializing");
    $aa1f5cc61f06db5d$var$startObservingMutations();
    $aa1f5cc61f06db5d$var$onElAdded((el)=>$aa1f5cc61f06db5d$var$initTree(el, $aa1f5cc61f06db5d$var$walk));
    $aa1f5cc61f06db5d$var$onElRemoved((el)=>$aa1f5cc61f06db5d$var$destroyTree(el));
    $aa1f5cc61f06db5d$var$onAttributesAdded((el, attrs)=>{
        $aa1f5cc61f06db5d$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$aa1f5cc61f06db5d$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($aa1f5cc61f06db5d$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $aa1f5cc61f06db5d$var$initTree(el);
    });
    $aa1f5cc61f06db5d$var$dispatch(document, "alpine:initialized");
}
var $aa1f5cc61f06db5d$var$rootSelectorCallbacks = [];
var $aa1f5cc61f06db5d$var$initSelectorCallbacks = [];
function $aa1f5cc61f06db5d$var$rootSelectors() {
    return $aa1f5cc61f06db5d$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $aa1f5cc61f06db5d$var$allSelectors() {
    return $aa1f5cc61f06db5d$var$rootSelectorCallbacks.concat($aa1f5cc61f06db5d$var$initSelectorCallbacks).map((fn)=>fn());
}
function $aa1f5cc61f06db5d$var$addRootSelector(selectorCallback) {
    $aa1f5cc61f06db5d$var$rootSelectorCallbacks.push(selectorCallback);
}
function $aa1f5cc61f06db5d$var$addInitSelector(selectorCallback) {
    $aa1f5cc61f06db5d$var$initSelectorCallbacks.push(selectorCallback);
}
function $aa1f5cc61f06db5d$var$closestRoot(el, includeInitSelectors = false) {
    return $aa1f5cc61f06db5d$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $aa1f5cc61f06db5d$var$allSelectors() : $aa1f5cc61f06db5d$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $aa1f5cc61f06db5d$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $aa1f5cc61f06db5d$var$findClosest(el.parentElement, callback);
}
function $aa1f5cc61f06db5d$var$isRoot(el) {
    return $aa1f5cc61f06db5d$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $aa1f5cc61f06db5d$var$initInterceptors = [];
function $aa1f5cc61f06db5d$var$interceptInit(callback) {
    $aa1f5cc61f06db5d$var$initInterceptors.push(callback);
}
function $aa1f5cc61f06db5d$var$initTree(el, walker = $aa1f5cc61f06db5d$var$walk, intercept = ()=>{}) {
    $aa1f5cc61f06db5d$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $aa1f5cc61f06db5d$var$initInterceptors.forEach((i)=>i(el2, skip));
            $aa1f5cc61f06db5d$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $aa1f5cc61f06db5d$var$destroyTree(root) {
    $aa1f5cc61f06db5d$var$walk(root, (el)=>{
        $aa1f5cc61f06db5d$var$cleanupAttributes(el);
        $aa1f5cc61f06db5d$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $aa1f5cc61f06db5d$var$onAttributeAddeds = [];
var $aa1f5cc61f06db5d$var$onElRemoveds = [];
var $aa1f5cc61f06db5d$var$onElAddeds = [];
function $aa1f5cc61f06db5d$var$onElAdded(callback) {
    $aa1f5cc61f06db5d$var$onElAddeds.push(callback);
}
function $aa1f5cc61f06db5d$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $aa1f5cc61f06db5d$var$onElRemoveds.push(callback);
    }
}
function $aa1f5cc61f06db5d$var$onAttributesAdded(callback) {
    $aa1f5cc61f06db5d$var$onAttributeAddeds.push(callback);
}
function $aa1f5cc61f06db5d$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $aa1f5cc61f06db5d$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $aa1f5cc61f06db5d$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $aa1f5cc61f06db5d$var$observer = new MutationObserver($aa1f5cc61f06db5d$var$onMutate);
var $aa1f5cc61f06db5d$var$currentlyObserving = false;
function $aa1f5cc61f06db5d$var$startObservingMutations() {
    $aa1f5cc61f06db5d$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $aa1f5cc61f06db5d$var$currentlyObserving = true;
}
function $aa1f5cc61f06db5d$var$stopObservingMutations() {
    $aa1f5cc61f06db5d$var$flushObserver();
    $aa1f5cc61f06db5d$var$observer.disconnect();
    $aa1f5cc61f06db5d$var$currentlyObserving = false;
}
var $aa1f5cc61f06db5d$var$queuedMutations = [];
function $aa1f5cc61f06db5d$var$flushObserver() {
    let records = $aa1f5cc61f06db5d$var$observer.takeRecords();
    $aa1f5cc61f06db5d$var$queuedMutations.push(()=>records.length > 0 && $aa1f5cc61f06db5d$var$onMutate(records));
    let queueLengthWhenTriggered = $aa1f5cc61f06db5d$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($aa1f5cc61f06db5d$var$queuedMutations.length === queueLengthWhenTriggered) while($aa1f5cc61f06db5d$var$queuedMutations.length > 0)$aa1f5cc61f06db5d$var$queuedMutations.shift()();
    });
}
function $aa1f5cc61f06db5d$var$mutateDom(callback) {
    if (!$aa1f5cc61f06db5d$var$currentlyObserving) return callback();
    $aa1f5cc61f06db5d$var$stopObservingMutations();
    let result = callback();
    $aa1f5cc61f06db5d$var$startObservingMutations();
    return result;
}
var $aa1f5cc61f06db5d$var$isCollecting = false;
var $aa1f5cc61f06db5d$var$deferredMutations = [];
function $aa1f5cc61f06db5d$var$deferMutations() {
    $aa1f5cc61f06db5d$var$isCollecting = true;
}
function $aa1f5cc61f06db5d$var$flushAndStopDeferringMutations() {
    $aa1f5cc61f06db5d$var$isCollecting = false;
    $aa1f5cc61f06db5d$var$onMutate($aa1f5cc61f06db5d$var$deferredMutations);
    $aa1f5cc61f06db5d$var$deferredMutations = [];
}
function $aa1f5cc61f06db5d$var$onMutate(mutations) {
    if ($aa1f5cc61f06db5d$var$isCollecting) {
        $aa1f5cc61f06db5d$var$deferredMutations = $aa1f5cc61f06db5d$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $aa1f5cc61f06db5d$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $aa1f5cc61f06db5d$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $aa1f5cc61f06db5d$var$onElRemoveds.forEach((i)=>i(node));
        $aa1f5cc61f06db5d$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $aa1f5cc61f06db5d$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $aa1f5cc61f06db5d$var$scope(node) {
    return $aa1f5cc61f06db5d$var$mergeProxies($aa1f5cc61f06db5d$var$closestDataStack(node));
}
function $aa1f5cc61f06db5d$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$aa1f5cc61f06db5d$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $aa1f5cc61f06db5d$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $aa1f5cc61f06db5d$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $aa1f5cc61f06db5d$var$closestDataStack(node.parentNode);
}
function $aa1f5cc61f06db5d$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $aa1f5cc61f06db5d$var$mergeProxyTrap);
}
var $aa1f5cc61f06db5d$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $aa1f5cc61f06db5d$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $aa1f5cc61f06db5d$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $aa1f5cc61f06db5d$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $aa1f5cc61f06db5d$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$aa1f5cc61f06db5d$var$get(data2, path), (value)=>$aa1f5cc61f06db5d$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $aa1f5cc61f06db5d$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $aa1f5cc61f06db5d$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $aa1f5cc61f06db5d$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $aa1f5cc61f06db5d$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $aa1f5cc61f06db5d$var$magics = {};
function $aa1f5cc61f06db5d$var$magic(name, callback) {
    $aa1f5cc61f06db5d$var$magics[name] = callback;
}
function $aa1f5cc61f06db5d$var$injectMagics(obj, el) {
    Object.entries($aa1f5cc61f06db5d$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $aa1f5cc61f06db5d$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $aa1f5cc61f06db5d$var$interceptor,
                    ...utilities
                };
                $aa1f5cc61f06db5d$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $aa1f5cc61f06db5d$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $aa1f5cc61f06db5d$var$handleError(e, el, expression);
    }
}
function $aa1f5cc61f06db5d$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $aa1f5cc61f06db5d$var$shouldAutoEvaluateFunctions = true;
function $aa1f5cc61f06db5d$var$dontAutoEvaluateFunctions(callback) {
    let cache = $aa1f5cc61f06db5d$var$shouldAutoEvaluateFunctions;
    $aa1f5cc61f06db5d$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $aa1f5cc61f06db5d$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $aa1f5cc61f06db5d$var$evaluate(el, expression, extras = {}) {
    let result;
    $aa1f5cc61f06db5d$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $aa1f5cc61f06db5d$var$evaluateLater(...args) {
    return $aa1f5cc61f06db5d$var$theEvaluatorFunction(...args);
}
var $aa1f5cc61f06db5d$var$theEvaluatorFunction = $aa1f5cc61f06db5d$var$normalEvaluator;
function $aa1f5cc61f06db5d$var$setEvaluator(newEvaluator) {
    $aa1f5cc61f06db5d$var$theEvaluatorFunction = newEvaluator;
}
function $aa1f5cc61f06db5d$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $aa1f5cc61f06db5d$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$aa1f5cc61f06db5d$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $aa1f5cc61f06db5d$var$generateEvaluatorFromFunction(dataStack, expression) : $aa1f5cc61f06db5d$var$generateEvaluatorFromString(dataStack, expression, el);
    return $aa1f5cc61f06db5d$var$tryCatch.bind(null, el, expression, evaluator);
}
function $aa1f5cc61f06db5d$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($aa1f5cc61f06db5d$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $aa1f5cc61f06db5d$var$runIfTypeOfFunction(receiver, result);
    };
}
var $aa1f5cc61f06db5d$var$evaluatorMemo = {};
function $aa1f5cc61f06db5d$var$generateFunctionFromString(expression, el) {
    if ($aa1f5cc61f06db5d$var$evaluatorMemo[expression]) return $aa1f5cc61f06db5d$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $aa1f5cc61f06db5d$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $aa1f5cc61f06db5d$var$evaluatorMemo[expression] = func;
    return func;
}
function $aa1f5cc61f06db5d$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $aa1f5cc61f06db5d$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $aa1f5cc61f06db5d$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$aa1f5cc61f06db5d$var$handleError(error2, el, expression));
            if (func.finished) {
                $aa1f5cc61f06db5d$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $aa1f5cc61f06db5d$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$aa1f5cc61f06db5d$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $aa1f5cc61f06db5d$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($aa1f5cc61f06db5d$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$aa1f5cc61f06db5d$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$aa1f5cc61f06db5d$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $aa1f5cc61f06db5d$var$prefixAsString = "x-";
function $aa1f5cc61f06db5d$var$prefix(subject = "") {
    return $aa1f5cc61f06db5d$var$prefixAsString + subject;
}
function $aa1f5cc61f06db5d$var$setPrefix(newPrefix) {
    $aa1f5cc61f06db5d$var$prefixAsString = newPrefix;
}
var $aa1f5cc61f06db5d$var$directiveHandlers = {};
function $aa1f5cc61f06db5d$var$directive(name, callback) {
    $aa1f5cc61f06db5d$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$aa1f5cc61f06db5d$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $aa1f5cc61f06db5d$var$directiveOrder.indexOf(directive2);
            $aa1f5cc61f06db5d$var$directiveOrder.splice(pos >= 0 ? pos : $aa1f5cc61f06db5d$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $aa1f5cc61f06db5d$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $aa1f5cc61f06db5d$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($aa1f5cc61f06db5d$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($aa1f5cc61f06db5d$var$outNonAlpineAttributes).map($aa1f5cc61f06db5d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($aa1f5cc61f06db5d$var$byPriority);
    return directives2.map((directive2)=>{
        return $aa1f5cc61f06db5d$var$getDirectiveHandler(el, directive2);
    });
}
function $aa1f5cc61f06db5d$var$attributesOnly(attributes) {
    return Array.from(attributes).map($aa1f5cc61f06db5d$var$toTransformedAttributes()).filter((attr)=>!$aa1f5cc61f06db5d$var$outNonAlpineAttributes(attr));
}
var $aa1f5cc61f06db5d$var$isDeferringHandlers = false;
var $aa1f5cc61f06db5d$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $aa1f5cc61f06db5d$var$currentHandlerStackKey = Symbol();
function $aa1f5cc61f06db5d$var$deferHandlingDirectives(callback) {
    $aa1f5cc61f06db5d$var$isDeferringHandlers = true;
    let key = Symbol();
    $aa1f5cc61f06db5d$var$currentHandlerStackKey = key;
    $aa1f5cc61f06db5d$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($aa1f5cc61f06db5d$var$directiveHandlerStacks.get(key).length)$aa1f5cc61f06db5d$var$directiveHandlerStacks.get(key).shift()();
        $aa1f5cc61f06db5d$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $aa1f5cc61f06db5d$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $aa1f5cc61f06db5d$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $aa1f5cc61f06db5d$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $aa1f5cc61f06db5d$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $aa1f5cc61f06db5d$var$evaluateLater.bind($aa1f5cc61f06db5d$var$evaluateLater, el),
        evaluate: $aa1f5cc61f06db5d$var$evaluate.bind($aa1f5cc61f06db5d$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $aa1f5cc61f06db5d$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $aa1f5cc61f06db5d$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $aa1f5cc61f06db5d$var$getElementBoundUtilities(el);
    $aa1f5cc61f06db5d$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $aa1f5cc61f06db5d$var$isDeferringHandlers ? $aa1f5cc61f06db5d$var$directiveHandlerStacks.get($aa1f5cc61f06db5d$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $aa1f5cc61f06db5d$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $aa1f5cc61f06db5d$var$into = (i)=>i;
function $aa1f5cc61f06db5d$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $aa1f5cc61f06db5d$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $aa1f5cc61f06db5d$var$attributeTransformers = [];
function $aa1f5cc61f06db5d$var$mapAttributes(callback) {
    $aa1f5cc61f06db5d$var$attributeTransformers.push(callback);
}
function $aa1f5cc61f06db5d$var$outNonAlpineAttributes({ name: name }) {
    return $aa1f5cc61f06db5d$var$alpineAttributeRegex().test(name);
}
var $aa1f5cc61f06db5d$var$alpineAttributeRegex = ()=>new RegExp(`^${$aa1f5cc61f06db5d$var$prefixAsString}([^:^.]+)\\b`);
function $aa1f5cc61f06db5d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($aa1f5cc61f06db5d$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $aa1f5cc61f06db5d$var$DEFAULT = "DEFAULT";
var $aa1f5cc61f06db5d$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $aa1f5cc61f06db5d$var$DEFAULT,
    "teleport"
];
function $aa1f5cc61f06db5d$var$byPriority(a, b) {
    let typeA = $aa1f5cc61f06db5d$var$directiveOrder.indexOf(a.type) === -1 ? $aa1f5cc61f06db5d$var$DEFAULT : a.type;
    let typeB = $aa1f5cc61f06db5d$var$directiveOrder.indexOf(b.type) === -1 ? $aa1f5cc61f06db5d$var$DEFAULT : b.type;
    return $aa1f5cc61f06db5d$var$directiveOrder.indexOf(typeA) - $aa1f5cc61f06db5d$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $aa1f5cc61f06db5d$var$tickStack = [];
var $aa1f5cc61f06db5d$var$isHolding = false;
function $aa1f5cc61f06db5d$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $aa1f5cc61f06db5d$var$isHolding || setTimeout(()=>{
            $aa1f5cc61f06db5d$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $aa1f5cc61f06db5d$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $aa1f5cc61f06db5d$var$releaseNextTicks() {
    $aa1f5cc61f06db5d$var$isHolding = false;
    while($aa1f5cc61f06db5d$var$tickStack.length)$aa1f5cc61f06db5d$var$tickStack.shift()();
}
function $aa1f5cc61f06db5d$var$holdNextTicks() {
    $aa1f5cc61f06db5d$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $aa1f5cc61f06db5d$var$setClasses(el, value) {
    if (Array.isArray(value)) return $aa1f5cc61f06db5d$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $aa1f5cc61f06db5d$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $aa1f5cc61f06db5d$var$setClasses(el, value());
    return $aa1f5cc61f06db5d$var$setClassesFromString(el, value);
}
function $aa1f5cc61f06db5d$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $aa1f5cc61f06db5d$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $aa1f5cc61f06db5d$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $aa1f5cc61f06db5d$var$setStylesFromObject(el, value);
    return $aa1f5cc61f06db5d$var$setStylesFromString(el, value);
}
function $aa1f5cc61f06db5d$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $aa1f5cc61f06db5d$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $aa1f5cc61f06db5d$var$setStyles(el, previousStyles);
    };
}
function $aa1f5cc61f06db5d$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $aa1f5cc61f06db5d$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $aa1f5cc61f06db5d$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$aa1f5cc61f06db5d$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $aa1f5cc61f06db5d$var$registerTransitionsFromHelper(el, modifiers, value);
    else $aa1f5cc61f06db5d$var$registerTransitionsFromClassString(el, expression, value);
});
function $aa1f5cc61f06db5d$var$registerTransitionsFromClassString(el, classString, stage) {
    $aa1f5cc61f06db5d$var$registerTransitionObject(el, $aa1f5cc61f06db5d$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $aa1f5cc61f06db5d$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $aa1f5cc61f06db5d$var$registerTransitionObject(el, $aa1f5cc61f06db5d$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $aa1f5cc61f06db5d$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $aa1f5cc61f06db5d$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $aa1f5cc61f06db5d$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $aa1f5cc61f06db5d$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $aa1f5cc61f06db5d$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $aa1f5cc61f06db5d$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $aa1f5cc61f06db5d$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $aa1f5cc61f06db5d$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $aa1f5cc61f06db5d$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $aa1f5cc61f06db5d$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $aa1f5cc61f06db5d$var$closestHide(parent);
}
function $aa1f5cc61f06db5d$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $aa1f5cc61f06db5d$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $aa1f5cc61f06db5d$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $aa1f5cc61f06db5d$var$once(()=>{
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $aa1f5cc61f06db5d$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $aa1f5cc61f06db5d$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $aa1f5cc61f06db5d$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $aa1f5cc61f06db5d$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $aa1f5cc61f06db5d$var$mutateDom(()=>{
                stages.end();
            });
            $aa1f5cc61f06db5d$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $aa1f5cc61f06db5d$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $aa1f5cc61f06db5d$var$isCloning = false;
function $aa1f5cc61f06db5d$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$aa1f5cc61f06db5d$var$isCloning ? fallback(...args) : callback(...args);
}
function $aa1f5cc61f06db5d$var$onlyDuringClone(callback) {
    return (...args)=>$aa1f5cc61f06db5d$var$isCloning && callback(...args);
}
var $aa1f5cc61f06db5d$var$interceptors = [];
function $aa1f5cc61f06db5d$var$interceptClone(callback) {
    $aa1f5cc61f06db5d$var$interceptors.push(callback);
}
function $aa1f5cc61f06db5d$var$cloneNode(from, to) {
    $aa1f5cc61f06db5d$var$interceptors.forEach((i)=>i(from, to));
    $aa1f5cc61f06db5d$var$isCloning = true;
    $aa1f5cc61f06db5d$var$dontRegisterReactiveSideEffects(()=>{
        $aa1f5cc61f06db5d$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $aa1f5cc61f06db5d$var$isCloning = false;
}
var $aa1f5cc61f06db5d$var$isCloningLegacy = false;
function $aa1f5cc61f06db5d$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $aa1f5cc61f06db5d$var$isCloning = true;
    $aa1f5cc61f06db5d$var$isCloningLegacy = true;
    $aa1f5cc61f06db5d$var$dontRegisterReactiveSideEffects(()=>{
        $aa1f5cc61f06db5d$var$cloneTree(newEl);
    });
    $aa1f5cc61f06db5d$var$isCloning = false;
    $aa1f5cc61f06db5d$var$isCloningLegacy = false;
}
function $aa1f5cc61f06db5d$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $aa1f5cc61f06db5d$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $aa1f5cc61f06db5d$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $aa1f5cc61f06db5d$var$initTree(el, shallowWalker);
}
function $aa1f5cc61f06db5d$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $aa1f5cc61f06db5d$var$effect;
    $aa1f5cc61f06db5d$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $aa1f5cc61f06db5d$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $aa1f5cc61f06db5d$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $aa1f5cc61f06db5d$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $aa1f5cc61f06db5d$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $aa1f5cc61f06db5d$var$camelCase(name) : name;
    switch(name){
        case "value":
            $aa1f5cc61f06db5d$var$bindInputValue(el, value);
            break;
        case "style":
            $aa1f5cc61f06db5d$var$bindStyles(el, value);
            break;
        case "class":
            $aa1f5cc61f06db5d$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $aa1f5cc61f06db5d$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $aa1f5cc61f06db5d$var$bindAttribute(el, name, value);
            break;
    }
}
function $aa1f5cc61f06db5d$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $aa1f5cc61f06db5d$var$safeParseBoolean(el.value) === value;
            else el.checked = $aa1f5cc61f06db5d$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$aa1f5cc61f06db5d$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $aa1f5cc61f06db5d$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $aa1f5cc61f06db5d$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $aa1f5cc61f06db5d$var$setClasses(el, value);
}
function $aa1f5cc61f06db5d$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $aa1f5cc61f06db5d$var$setStyles(el, value);
}
function $aa1f5cc61f06db5d$var$bindAttributeAndProperty(el, name, value) {
    $aa1f5cc61f06db5d$var$bindAttribute(el, name, value);
    $aa1f5cc61f06db5d$var$setPropertyIfChanged(el, name, value);
}
function $aa1f5cc61f06db5d$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $aa1f5cc61f06db5d$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($aa1f5cc61f06db5d$var$isBooleanAttr(name)) value = name;
        $aa1f5cc61f06db5d$var$setIfChanged(el, name, value);
    }
}
function $aa1f5cc61f06db5d$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $aa1f5cc61f06db5d$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $aa1f5cc61f06db5d$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $aa1f5cc61f06db5d$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $aa1f5cc61f06db5d$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $aa1f5cc61f06db5d$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $aa1f5cc61f06db5d$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $aa1f5cc61f06db5d$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $aa1f5cc61f06db5d$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $aa1f5cc61f06db5d$var$getAttributeBinding(el, name, fallback);
}
function $aa1f5cc61f06db5d$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $aa1f5cc61f06db5d$var$dontAutoEvaluateFunctions(()=>{
            return $aa1f5cc61f06db5d$var$evaluate(el, binding.expression);
        });
    }
    return $aa1f5cc61f06db5d$var$getAttributeBinding(el, name, fallback);
}
function $aa1f5cc61f06db5d$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($aa1f5cc61f06db5d$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $aa1f5cc61f06db5d$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $aa1f5cc61f06db5d$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $aa1f5cc61f06db5d$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $aa1f5cc61f06db5d$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($aa1f5cc61f06db5d$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($aa1f5cc61f06db5d$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($aa1f5cc61f06db5d$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $aa1f5cc61f06db5d$var$release(reference);
    };
}
function $aa1f5cc61f06db5d$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $aa1f5cc61f06db5d$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($aa1f5cc61f06db5d$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $aa1f5cc61f06db5d$var$stores = {};
var $aa1f5cc61f06db5d$var$isReactive = false;
function $aa1f5cc61f06db5d$var$store(name, value) {
    if (!$aa1f5cc61f06db5d$var$isReactive) {
        $aa1f5cc61f06db5d$var$stores = $aa1f5cc61f06db5d$var$reactive($aa1f5cc61f06db5d$var$stores);
        $aa1f5cc61f06db5d$var$isReactive = true;
    }
    if (value === void 0) return $aa1f5cc61f06db5d$var$stores[name];
    $aa1f5cc61f06db5d$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $aa1f5cc61f06db5d$var$stores[name].init();
    $aa1f5cc61f06db5d$var$initInterceptors2($aa1f5cc61f06db5d$var$stores[name]);
}
function $aa1f5cc61f06db5d$var$getStores() {
    return $aa1f5cc61f06db5d$var$stores;
}
// packages/alpinejs/src/binds.js
var $aa1f5cc61f06db5d$var$binds = {};
function $aa1f5cc61f06db5d$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $aa1f5cc61f06db5d$var$applyBindingsObject(name, getBindings());
    else $aa1f5cc61f06db5d$var$binds[name] = getBindings;
    return ()=>{};
}
function $aa1f5cc61f06db5d$var$injectBindingProviders(obj) {
    Object.entries($aa1f5cc61f06db5d$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $aa1f5cc61f06db5d$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $aa1f5cc61f06db5d$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $aa1f5cc61f06db5d$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $aa1f5cc61f06db5d$var$datas = {};
function $aa1f5cc61f06db5d$var$data(name, callback) {
    $aa1f5cc61f06db5d$var$datas[name] = callback;
}
function $aa1f5cc61f06db5d$var$injectDataProviders(obj, context) {
    Object.entries($aa1f5cc61f06db5d$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $aa1f5cc61f06db5d$var$Alpine = {
    get reactive () {
        return $aa1f5cc61f06db5d$var$reactive;
    },
    get release () {
        return $aa1f5cc61f06db5d$var$release;
    },
    get effect () {
        return $aa1f5cc61f06db5d$var$effect;
    },
    get raw () {
        return $aa1f5cc61f06db5d$var$raw;
    },
    version: "3.13.5",
    flushAndStopDeferringMutations: $aa1f5cc61f06db5d$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $aa1f5cc61f06db5d$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $aa1f5cc61f06db5d$var$disableEffectScheduling,
    startObservingMutations: $aa1f5cc61f06db5d$var$startObservingMutations,
    stopObservingMutations: $aa1f5cc61f06db5d$var$stopObservingMutations,
    setReactivityEngine: $aa1f5cc61f06db5d$var$setReactivityEngine,
    onAttributeRemoved: $aa1f5cc61f06db5d$var$onAttributeRemoved,
    onAttributesAdded: $aa1f5cc61f06db5d$var$onAttributesAdded,
    closestDataStack: $aa1f5cc61f06db5d$var$closestDataStack,
    skipDuringClone: $aa1f5cc61f06db5d$var$skipDuringClone,
    onlyDuringClone: $aa1f5cc61f06db5d$var$onlyDuringClone,
    addRootSelector: $aa1f5cc61f06db5d$var$addRootSelector,
    addInitSelector: $aa1f5cc61f06db5d$var$addInitSelector,
    interceptClone: $aa1f5cc61f06db5d$var$interceptClone,
    addScopeToNode: $aa1f5cc61f06db5d$var$addScopeToNode,
    deferMutations: $aa1f5cc61f06db5d$var$deferMutations,
    mapAttributes: $aa1f5cc61f06db5d$var$mapAttributes,
    evaluateLater: $aa1f5cc61f06db5d$var$evaluateLater,
    interceptInit: $aa1f5cc61f06db5d$var$interceptInit,
    setEvaluator: $aa1f5cc61f06db5d$var$setEvaluator,
    mergeProxies: $aa1f5cc61f06db5d$var$mergeProxies,
    extractProp: $aa1f5cc61f06db5d$var$extractProp,
    findClosest: $aa1f5cc61f06db5d$var$findClosest,
    onElRemoved: $aa1f5cc61f06db5d$var$onElRemoved,
    closestRoot: $aa1f5cc61f06db5d$var$closestRoot,
    destroyTree: $aa1f5cc61f06db5d$var$destroyTree,
    interceptor: $aa1f5cc61f06db5d$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $aa1f5cc61f06db5d$var$transition,
    setStyles: // INTERNAL
    $aa1f5cc61f06db5d$var$setStyles,
    mutateDom: // INTERNAL
    $aa1f5cc61f06db5d$var$mutateDom,
    directive: $aa1f5cc61f06db5d$var$directive,
    entangle: $aa1f5cc61f06db5d$var$entangle,
    throttle: $aa1f5cc61f06db5d$var$throttle,
    debounce: $aa1f5cc61f06db5d$var$debounce,
    evaluate: $aa1f5cc61f06db5d$var$evaluate,
    initTree: $aa1f5cc61f06db5d$var$initTree,
    nextTick: $aa1f5cc61f06db5d$var$nextTick,
    prefixed: $aa1f5cc61f06db5d$var$prefix,
    prefix: $aa1f5cc61f06db5d$var$setPrefix,
    plugin: $aa1f5cc61f06db5d$var$plugin,
    magic: $aa1f5cc61f06db5d$var$magic,
    store: $aa1f5cc61f06db5d$var$store,
    start: $aa1f5cc61f06db5d$var$start,
    clone: $aa1f5cc61f06db5d$var$clone,
    cloneNode: // INTERNAL
    $aa1f5cc61f06db5d$var$cloneNode,
    // INTERNAL
    bound: $aa1f5cc61f06db5d$var$getBinding,
    $data: $aa1f5cc61f06db5d$var$scope,
    watch: $aa1f5cc61f06db5d$var$watch,
    walk: $aa1f5cc61f06db5d$var$walk,
    data: $aa1f5cc61f06db5d$var$data,
    bind: $aa1f5cc61f06db5d$var$bind2
};
var $aa1f5cc61f06db5d$var$alpine_default = $aa1f5cc61f06db5d$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $aa1f5cc61f06db5d$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $aa1f5cc61f06db5d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $aa1f5cc61f06db5d$var$isBooleanAttr2 = /* @__PURE__ */ $aa1f5cc61f06db5d$var$makeMap($aa1f5cc61f06db5d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $aa1f5cc61f06db5d$var$EMPTY_OBJ = Object.freeze({});
var $aa1f5cc61f06db5d$var$EMPTY_ARR = Object.freeze([]);
var $aa1f5cc61f06db5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $aa1f5cc61f06db5d$var$hasOwn = (val, key)=>$aa1f5cc61f06db5d$var$hasOwnProperty.call(val, key);
var $aa1f5cc61f06db5d$var$isArray = Array.isArray;
var $aa1f5cc61f06db5d$var$isMap = (val)=>$aa1f5cc61f06db5d$var$toTypeString(val) === "[object Map]";
var $aa1f5cc61f06db5d$var$isString = (val)=>typeof val === "string";
var $aa1f5cc61f06db5d$var$isSymbol = (val)=>typeof val === "symbol";
var $aa1f5cc61f06db5d$var$isObject = (val)=>val !== null && typeof val === "object";
var $aa1f5cc61f06db5d$var$objectToString = Object.prototype.toString;
var $aa1f5cc61f06db5d$var$toTypeString = (value)=>$aa1f5cc61f06db5d$var$objectToString.call(value);
var $aa1f5cc61f06db5d$var$toRawType = (value)=>{
    return $aa1f5cc61f06db5d$var$toTypeString(value).slice(8, -1);
};
var $aa1f5cc61f06db5d$var$isIntegerKey = (key)=>$aa1f5cc61f06db5d$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $aa1f5cc61f06db5d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $aa1f5cc61f06db5d$var$camelizeRE = /-(\w)/g;
var $aa1f5cc61f06db5d$var$camelize = $aa1f5cc61f06db5d$var$cacheStringFunction((str)=>{
    return str.replace($aa1f5cc61f06db5d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $aa1f5cc61f06db5d$var$hyphenateRE = /\B([A-Z])/g;
var $aa1f5cc61f06db5d$var$hyphenate = $aa1f5cc61f06db5d$var$cacheStringFunction((str)=>str.replace($aa1f5cc61f06db5d$var$hyphenateRE, "-$1").toLowerCase());
var $aa1f5cc61f06db5d$var$capitalize = $aa1f5cc61f06db5d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $aa1f5cc61f06db5d$var$toHandlerKey = $aa1f5cc61f06db5d$var$cacheStringFunction((str)=>str ? `on${$aa1f5cc61f06db5d$var$capitalize(str)}` : ``);
var $aa1f5cc61f06db5d$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $aa1f5cc61f06db5d$var$targetMap = /* @__PURE__ */ new WeakMap();
var $aa1f5cc61f06db5d$var$effectStack = [];
var $aa1f5cc61f06db5d$var$activeEffect;
var $aa1f5cc61f06db5d$var$ITERATE_KEY = Symbol("iterate");
var $aa1f5cc61f06db5d$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $aa1f5cc61f06db5d$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $aa1f5cc61f06db5d$var$effect2(fn, options = $aa1f5cc61f06db5d$var$EMPTY_OBJ) {
    if ($aa1f5cc61f06db5d$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $aa1f5cc61f06db5d$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $aa1f5cc61f06db5d$var$stop(effect3) {
    if (effect3.active) {
        $aa1f5cc61f06db5d$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $aa1f5cc61f06db5d$var$uid = 0;
function $aa1f5cc61f06db5d$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$aa1f5cc61f06db5d$var$effectStack.includes(effect3)) {
            $aa1f5cc61f06db5d$var$cleanup(effect3);
            try {
                $aa1f5cc61f06db5d$var$enableTracking();
                $aa1f5cc61f06db5d$var$effectStack.push(effect3);
                $aa1f5cc61f06db5d$var$activeEffect = effect3;
                return fn();
            } finally{
                $aa1f5cc61f06db5d$var$effectStack.pop();
                $aa1f5cc61f06db5d$var$resetTracking();
                $aa1f5cc61f06db5d$var$activeEffect = $aa1f5cc61f06db5d$var$effectStack[$aa1f5cc61f06db5d$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $aa1f5cc61f06db5d$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $aa1f5cc61f06db5d$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $aa1f5cc61f06db5d$var$shouldTrack = true;
var $aa1f5cc61f06db5d$var$trackStack = [];
function $aa1f5cc61f06db5d$var$pauseTracking() {
    $aa1f5cc61f06db5d$var$trackStack.push($aa1f5cc61f06db5d$var$shouldTrack);
    $aa1f5cc61f06db5d$var$shouldTrack = false;
}
function $aa1f5cc61f06db5d$var$enableTracking() {
    $aa1f5cc61f06db5d$var$trackStack.push($aa1f5cc61f06db5d$var$shouldTrack);
    $aa1f5cc61f06db5d$var$shouldTrack = true;
}
function $aa1f5cc61f06db5d$var$resetTracking() {
    const last = $aa1f5cc61f06db5d$var$trackStack.pop();
    $aa1f5cc61f06db5d$var$shouldTrack = last === void 0 ? true : last;
}
function $aa1f5cc61f06db5d$var$track(target, type, key) {
    if (!$aa1f5cc61f06db5d$var$shouldTrack || $aa1f5cc61f06db5d$var$activeEffect === void 0) return;
    let depsMap = $aa1f5cc61f06db5d$var$targetMap.get(target);
    if (!depsMap) $aa1f5cc61f06db5d$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($aa1f5cc61f06db5d$var$activeEffect)) {
        dep.add($aa1f5cc61f06db5d$var$activeEffect);
        $aa1f5cc61f06db5d$var$activeEffect.deps.push(dep);
        if ($aa1f5cc61f06db5d$var$activeEffect.options.onTrack) $aa1f5cc61f06db5d$var$activeEffect.options.onTrack({
            effect: $aa1f5cc61f06db5d$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $aa1f5cc61f06db5d$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $aa1f5cc61f06db5d$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $aa1f5cc61f06db5d$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $aa1f5cc61f06db5d$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$aa1f5cc61f06db5d$var$isArray(target)) {
                    add2(depsMap.get($aa1f5cc61f06db5d$var$ITERATE_KEY));
                    if ($aa1f5cc61f06db5d$var$isMap(target)) add2(depsMap.get($aa1f5cc61f06db5d$var$MAP_KEY_ITERATE_KEY));
                } else if ($aa1f5cc61f06db5d$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$aa1f5cc61f06db5d$var$isArray(target)) {
                    add2(depsMap.get($aa1f5cc61f06db5d$var$ITERATE_KEY));
                    if ($aa1f5cc61f06db5d$var$isMap(target)) add2(depsMap.get($aa1f5cc61f06db5d$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($aa1f5cc61f06db5d$var$isMap(target)) add2(depsMap.get($aa1f5cc61f06db5d$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $aa1f5cc61f06db5d$var$isNonTrackableKeys = /* @__PURE__ */ $aa1f5cc61f06db5d$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $aa1f5cc61f06db5d$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($aa1f5cc61f06db5d$var$isSymbol));
var $aa1f5cc61f06db5d$var$get2 = /* @__PURE__ */ $aa1f5cc61f06db5d$var$createGetter();
var $aa1f5cc61f06db5d$var$readonlyGet = /* @__PURE__ */ $aa1f5cc61f06db5d$var$createGetter(true);
var $aa1f5cc61f06db5d$var$arrayInstrumentations = /* @__PURE__ */ $aa1f5cc61f06db5d$var$createArrayInstrumentations();
function $aa1f5cc61f06db5d$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $aa1f5cc61f06db5d$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$aa1f5cc61f06db5d$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($aa1f5cc61f06db5d$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $aa1f5cc61f06db5d$var$pauseTracking();
            const res = $aa1f5cc61f06db5d$var$toRaw(this)[key].apply(this, args);
            $aa1f5cc61f06db5d$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $aa1f5cc61f06db5d$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $aa1f5cc61f06db5d$var$shallowReadonlyMap : $aa1f5cc61f06db5d$var$readonlyMap : shallow ? $aa1f5cc61f06db5d$var$shallowReactiveMap : $aa1f5cc61f06db5d$var$reactiveMap).get(target)) return target;
        const targetIsArray = $aa1f5cc61f06db5d$var$isArray(target);
        if (!isReadonly && targetIsArray && $aa1f5cc61f06db5d$var$hasOwn($aa1f5cc61f06db5d$var$arrayInstrumentations, key)) return Reflect.get($aa1f5cc61f06db5d$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($aa1f5cc61f06db5d$var$isSymbol(key) ? $aa1f5cc61f06db5d$var$builtInSymbols.has(key) : $aa1f5cc61f06db5d$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $aa1f5cc61f06db5d$var$track(target, "get", key);
        if (shallow) return res;
        if ($aa1f5cc61f06db5d$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$aa1f5cc61f06db5d$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($aa1f5cc61f06db5d$var$isObject(res)) return isReadonly ? $aa1f5cc61f06db5d$var$readonly(res) : $aa1f5cc61f06db5d$var$reactive2(res);
        return res;
    };
}
var $aa1f5cc61f06db5d$var$set2 = /* @__PURE__ */ $aa1f5cc61f06db5d$var$createSetter();
function $aa1f5cc61f06db5d$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $aa1f5cc61f06db5d$var$toRaw(value);
            oldValue = $aa1f5cc61f06db5d$var$toRaw(oldValue);
            if (!$aa1f5cc61f06db5d$var$isArray(target) && $aa1f5cc61f06db5d$var$isRef(oldValue) && !$aa1f5cc61f06db5d$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $aa1f5cc61f06db5d$var$isArray(target) && $aa1f5cc61f06db5d$var$isIntegerKey(key) ? Number(key) < target.length : $aa1f5cc61f06db5d$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $aa1f5cc61f06db5d$var$toRaw(receiver)) {
            if (!hadKey) $aa1f5cc61f06db5d$var$trigger(target, "add", key, value);
            else if ($aa1f5cc61f06db5d$var$hasChanged(value, oldValue)) $aa1f5cc61f06db5d$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $aa1f5cc61f06db5d$var$deleteProperty(target, key) {
    const hadKey = $aa1f5cc61f06db5d$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $aa1f5cc61f06db5d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $aa1f5cc61f06db5d$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$aa1f5cc61f06db5d$var$isSymbol(key) || !$aa1f5cc61f06db5d$var$builtInSymbols.has(key)) $aa1f5cc61f06db5d$var$track(target, "has", key);
    return result;
}
function $aa1f5cc61f06db5d$var$ownKeys(target) {
    $aa1f5cc61f06db5d$var$track(target, "iterate", $aa1f5cc61f06db5d$var$isArray(target) ? "length" : $aa1f5cc61f06db5d$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $aa1f5cc61f06db5d$var$mutableHandlers = {
    get: $aa1f5cc61f06db5d$var$get2,
    set: $aa1f5cc61f06db5d$var$set2,
    deleteProperty: $aa1f5cc61f06db5d$var$deleteProperty,
    has: $aa1f5cc61f06db5d$var$has,
    ownKeys: $aa1f5cc61f06db5d$var$ownKeys
};
var $aa1f5cc61f06db5d$var$readonlyHandlers = {
    get: $aa1f5cc61f06db5d$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $aa1f5cc61f06db5d$var$toReactive = (value)=>$aa1f5cc61f06db5d$var$isObject(value) ? $aa1f5cc61f06db5d$var$reactive2(value) : value;
var $aa1f5cc61f06db5d$var$toReadonly = (value)=>$aa1f5cc61f06db5d$var$isObject(value) ? $aa1f5cc61f06db5d$var$readonly(value) : value;
var $aa1f5cc61f06db5d$var$toShallow = (value)=>value;
var $aa1f5cc61f06db5d$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $aa1f5cc61f06db5d$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $aa1f5cc61f06db5d$var$toRaw(target);
    const rawKey = $aa1f5cc61f06db5d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "get", key);
    !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $aa1f5cc61f06db5d$var$getProto(rawTarget);
    const wrap = isShallow ? $aa1f5cc61f06db5d$var$toShallow : isReadonly ? $aa1f5cc61f06db5d$var$toReadonly : $aa1f5cc61f06db5d$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $aa1f5cc61f06db5d$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $aa1f5cc61f06db5d$var$toRaw(target);
    const rawKey = $aa1f5cc61f06db5d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "has", key);
    !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $aa1f5cc61f06db5d$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $aa1f5cc61f06db5d$var$track($aa1f5cc61f06db5d$var$toRaw(target), "iterate", $aa1f5cc61f06db5d$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $aa1f5cc61f06db5d$var$add(value) {
    value = $aa1f5cc61f06db5d$var$toRaw(value);
    const target = $aa1f5cc61f06db5d$var$toRaw(this);
    const proto = $aa1f5cc61f06db5d$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $aa1f5cc61f06db5d$var$trigger(target, "add", value, value);
    }
    return this;
}
function $aa1f5cc61f06db5d$var$set$1(key, value) {
    value = $aa1f5cc61f06db5d$var$toRaw(value);
    const target = $aa1f5cc61f06db5d$var$toRaw(this);
    const { has: has2, get: get3 } = $aa1f5cc61f06db5d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $aa1f5cc61f06db5d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $aa1f5cc61f06db5d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $aa1f5cc61f06db5d$var$trigger(target, "add", key, value);
    else if ($aa1f5cc61f06db5d$var$hasChanged(value, oldValue)) $aa1f5cc61f06db5d$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $aa1f5cc61f06db5d$var$deleteEntry(key) {
    const target = $aa1f5cc61f06db5d$var$toRaw(this);
    const { has: has2, get: get3 } = $aa1f5cc61f06db5d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $aa1f5cc61f06db5d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $aa1f5cc61f06db5d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $aa1f5cc61f06db5d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $aa1f5cc61f06db5d$var$clear() {
    const target = $aa1f5cc61f06db5d$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $aa1f5cc61f06db5d$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $aa1f5cc61f06db5d$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $aa1f5cc61f06db5d$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $aa1f5cc61f06db5d$var$toRaw(target);
        const wrap = isShallow ? $aa1f5cc61f06db5d$var$toShallow : isReadonly ? $aa1f5cc61f06db5d$var$toReadonly : $aa1f5cc61f06db5d$var$toReactive;
        !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "iterate", $aa1f5cc61f06db5d$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $aa1f5cc61f06db5d$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $aa1f5cc61f06db5d$var$toRaw(target);
        const targetIsMap = $aa1f5cc61f06db5d$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $aa1f5cc61f06db5d$var$toShallow : isReadonly ? $aa1f5cc61f06db5d$var$toReadonly : $aa1f5cc61f06db5d$var$toReactive;
        !isReadonly && $aa1f5cc61f06db5d$var$track(rawTarget, "iterate", isKeyOnly ? $aa1f5cc61f06db5d$var$MAP_KEY_ITERATE_KEY : $aa1f5cc61f06db5d$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $aa1f5cc61f06db5d$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$aa1f5cc61f06db5d$var$capitalize(type)} operation ${key}failed: target is readonly.`, $aa1f5cc61f06db5d$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $aa1f5cc61f06db5d$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $aa1f5cc61f06db5d$var$get$1(this, key);
        },
        get size () {
            return $aa1f5cc61f06db5d$var$size(this);
        },
        has: $aa1f5cc61f06db5d$var$has$1,
        add: $aa1f5cc61f06db5d$var$add,
        set: $aa1f5cc61f06db5d$var$set$1,
        delete: $aa1f5cc61f06db5d$var$deleteEntry,
        clear: $aa1f5cc61f06db5d$var$clear,
        forEach: $aa1f5cc61f06db5d$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $aa1f5cc61f06db5d$var$get$1(this, key, false, true);
        },
        get size () {
            return $aa1f5cc61f06db5d$var$size(this);
        },
        has: $aa1f5cc61f06db5d$var$has$1,
        add: $aa1f5cc61f06db5d$var$add,
        set: $aa1f5cc61f06db5d$var$set$1,
        delete: $aa1f5cc61f06db5d$var$deleteEntry,
        clear: $aa1f5cc61f06db5d$var$clear,
        forEach: $aa1f5cc61f06db5d$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $aa1f5cc61f06db5d$var$get$1(this, key, true);
        },
        get size () {
            return $aa1f5cc61f06db5d$var$size(this, true);
        },
        has (key) {
            return $aa1f5cc61f06db5d$var$has$1.call(this, key, true);
        },
        add: $aa1f5cc61f06db5d$var$createReadonlyMethod("add"),
        set: $aa1f5cc61f06db5d$var$createReadonlyMethod("set"),
        delete: $aa1f5cc61f06db5d$var$createReadonlyMethod("delete"),
        clear: $aa1f5cc61f06db5d$var$createReadonlyMethod("clear"),
        forEach: $aa1f5cc61f06db5d$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $aa1f5cc61f06db5d$var$get$1(this, key, true, true);
        },
        get size () {
            return $aa1f5cc61f06db5d$var$size(this, true);
        },
        has (key) {
            return $aa1f5cc61f06db5d$var$has$1.call(this, key, true);
        },
        add: $aa1f5cc61f06db5d$var$createReadonlyMethod("add"),
        set: $aa1f5cc61f06db5d$var$createReadonlyMethod("set"),
        delete: $aa1f5cc61f06db5d$var$createReadonlyMethod("delete"),
        clear: $aa1f5cc61f06db5d$var$createReadonlyMethod("clear"),
        forEach: $aa1f5cc61f06db5d$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $aa1f5cc61f06db5d$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $aa1f5cc61f06db5d$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $aa1f5cc61f06db5d$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $aa1f5cc61f06db5d$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$aa1f5cc61f06db5d$var$mutableInstrumentations, $aa1f5cc61f06db5d$var$readonlyInstrumentations, $aa1f5cc61f06db5d$var$shallowInstrumentations, $aa1f5cc61f06db5d$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $aa1f5cc61f06db5d$var$createInstrumentations();
function $aa1f5cc61f06db5d$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $aa1f5cc61f06db5d$var$shallowReadonlyInstrumentations : $aa1f5cc61f06db5d$var$shallowInstrumentations : isReadonly ? $aa1f5cc61f06db5d$var$readonlyInstrumentations : $aa1f5cc61f06db5d$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($aa1f5cc61f06db5d$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $aa1f5cc61f06db5d$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $aa1f5cc61f06db5d$var$createInstrumentationGetter(false, false)
};
var $aa1f5cc61f06db5d$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $aa1f5cc61f06db5d$var$createInstrumentationGetter(true, false)
};
function $aa1f5cc61f06db5d$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $aa1f5cc61f06db5d$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $aa1f5cc61f06db5d$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $aa1f5cc61f06db5d$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $aa1f5cc61f06db5d$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $aa1f5cc61f06db5d$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $aa1f5cc61f06db5d$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $aa1f5cc61f06db5d$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $aa1f5cc61f06db5d$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $aa1f5cc61f06db5d$var$targetTypeMap($aa1f5cc61f06db5d$var$toRawType(value));
}
function $aa1f5cc61f06db5d$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $aa1f5cc61f06db5d$var$createReactiveObject(target, false, $aa1f5cc61f06db5d$var$mutableHandlers, $aa1f5cc61f06db5d$var$mutableCollectionHandlers, $aa1f5cc61f06db5d$var$reactiveMap);
}
function $aa1f5cc61f06db5d$var$readonly(target) {
    return $aa1f5cc61f06db5d$var$createReactiveObject(target, true, $aa1f5cc61f06db5d$var$readonlyHandlers, $aa1f5cc61f06db5d$var$readonlyCollectionHandlers, $aa1f5cc61f06db5d$var$readonlyMap);
}
function $aa1f5cc61f06db5d$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$aa1f5cc61f06db5d$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $aa1f5cc61f06db5d$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $aa1f5cc61f06db5d$var$toRaw(observed) {
    return observed && $aa1f5cc61f06db5d$var$toRaw(observed["__v_raw"]) || observed;
}
function $aa1f5cc61f06db5d$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$aa1f5cc61f06db5d$var$magic("nextTick", ()=>$aa1f5cc61f06db5d$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$aa1f5cc61f06db5d$var$magic("dispatch", (el)=>$aa1f5cc61f06db5d$var$dispatch.bind($aa1f5cc61f06db5d$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$aa1f5cc61f06db5d$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $aa1f5cc61f06db5d$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$aa1f5cc61f06db5d$var$magic("store", $aa1f5cc61f06db5d$var$getStores);
// packages/alpinejs/src/magics/$data.js
$aa1f5cc61f06db5d$var$magic("data", (el)=>$aa1f5cc61f06db5d$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$aa1f5cc61f06db5d$var$magic("root", (el)=>$aa1f5cc61f06db5d$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$aa1f5cc61f06db5d$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $aa1f5cc61f06db5d$var$mergeProxies($aa1f5cc61f06db5d$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $aa1f5cc61f06db5d$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $aa1f5cc61f06db5d$var$globalIdMemo = {};
function $aa1f5cc61f06db5d$var$findAndIncrementId(name) {
    if (!$aa1f5cc61f06db5d$var$globalIdMemo[name]) $aa1f5cc61f06db5d$var$globalIdMemo[name] = 0;
    return ++$aa1f5cc61f06db5d$var$globalIdMemo[name];
}
function $aa1f5cc61f06db5d$var$closestIdRoot(el, name) {
    return $aa1f5cc61f06db5d$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $aa1f5cc61f06db5d$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $aa1f5cc61f06db5d$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$aa1f5cc61f06db5d$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $aa1f5cc61f06db5d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $aa1f5cc61f06db5d$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $aa1f5cc61f06db5d$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$aa1f5cc61f06db5d$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $aa1f5cc61f06db5d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$aa1f5cc61f06db5d$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$aa1f5cc61f06db5d$var$warnMissingPluginMagic("Focus", "focus", "focus");
$aa1f5cc61f06db5d$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $aa1f5cc61f06db5d$var$warnMissingPluginMagic(name, magicName, slug) {
    $aa1f5cc61f06db5d$var$magic(magicName, (el)=>$aa1f5cc61f06db5d$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$aa1f5cc61f06db5d$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $aa1f5cc61f06db5d$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$aa1f5cc61f06db5d$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $aa1f5cc61f06db5d$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $aa1f5cc61f06db5d$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $aa1f5cc61f06db5d$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $aa1f5cc61f06db5d$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $aa1f5cc61f06db5d$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $aa1f5cc61f06db5d$var$getTarget(expression);
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $aa1f5cc61f06db5d$var$teleportContainerDuringClone = document.createElement("div");
function $aa1f5cc61f06db5d$var$getTarget(expression) {
    let target = $aa1f5cc61f06db5d$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $aa1f5cc61f06db5d$var$teleportContainerDuringClone;
    })();
    if (!target) $aa1f5cc61f06db5d$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $aa1f5cc61f06db5d$var$handler = ()=>{};
$aa1f5cc61f06db5d$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$aa1f5cc61f06db5d$var$directive("ignore", $aa1f5cc61f06db5d$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$aa1f5cc61f06db5d$var$directive("effect", $aa1f5cc61f06db5d$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($aa1f5cc61f06db5d$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $aa1f5cc61f06db5d$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $aa1f5cc61f06db5d$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $aa1f5cc61f06db5d$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $aa1f5cc61f06db5d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $aa1f5cc61f06db5d$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $aa1f5cc61f06db5d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $aa1f5cc61f06db5d$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($aa1f5cc61f06db5d$var$isKeyEvent(event)) {
            if ($aa1f5cc61f06db5d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $aa1f5cc61f06db5d$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $aa1f5cc61f06db5d$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $aa1f5cc61f06db5d$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $aa1f5cc61f06db5d$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $aa1f5cc61f06db5d$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $aa1f5cc61f06db5d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $aa1f5cc61f06db5d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $aa1f5cc61f06db5d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $aa1f5cc61f06db5d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($aa1f5cc61f06db5d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $aa1f5cc61f06db5d$var$keyToModifiers(key) {
    if (!key) return [];
    key = $aa1f5cc61f06db5d$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$aa1f5cc61f06db5d$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $aa1f5cc61f06db5d$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $aa1f5cc61f06db5d$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $aa1f5cc61f06db5d$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $aa1f5cc61f06db5d$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($aa1f5cc61f06db5d$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $aa1f5cc61f06db5d$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $aa1f5cc61f06db5d$var$isCloning ? ()=>{} : $aa1f5cc61f06db5d$var$on(el, event, modifiers, (e)=>{
        setValue($aa1f5cc61f06db5d$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $aa1f5cc61f06db5d$var$on(el.form, "reset", [], (e)=>{
            $aa1f5cc61f06db5d$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $aa1f5cc61f06db5d$var$mutateDom(()=>$aa1f5cc61f06db5d$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $aa1f5cc61f06db5d$var$getInputValue(el, modifiers, event, currentValue) {
    return $aa1f5cc61f06db5d$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $aa1f5cc61f06db5d$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $aa1f5cc61f06db5d$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$aa1f5cc61f06db5d$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $aa1f5cc61f06db5d$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $aa1f5cc61f06db5d$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $aa1f5cc61f06db5d$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $aa1f5cc61f06db5d$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $aa1f5cc61f06db5d$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $aa1f5cc61f06db5d$var$isNumeric2(number) ? number : rawValue;
}
function $aa1f5cc61f06db5d$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $aa1f5cc61f06db5d$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $aa1f5cc61f06db5d$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$aa1f5cc61f06db5d$var$directive("cloak", (el)=>queueMicrotask(()=>$aa1f5cc61f06db5d$var$mutateDom(()=>el.removeAttribute($aa1f5cc61f06db5d$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$aa1f5cc61f06db5d$var$addInitSelector(()=>`[${$aa1f5cc61f06db5d$var$prefix("init")}]`);
$aa1f5cc61f06db5d$var$directive("init", $aa1f5cc61f06db5d$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$aa1f5cc61f06db5d$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $aa1f5cc61f06db5d$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$aa1f5cc61f06db5d$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $aa1f5cc61f06db5d$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $aa1f5cc61f06db5d$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$aa1f5cc61f06db5d$var$mapAttributes($aa1f5cc61f06db5d$var$startingWith(":", $aa1f5cc61f06db5d$var$into($aa1f5cc61f06db5d$var$prefix("bind:"))));
var $aa1f5cc61f06db5d$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $aa1f5cc61f06db5d$var$injectBindingProviders(bindingProviders);
        let getBindings = $aa1f5cc61f06db5d$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $aa1f5cc61f06db5d$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $aa1f5cc61f06db5d$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $aa1f5cc61f06db5d$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $aa1f5cc61f06db5d$var$mutateDom(()=>$aa1f5cc61f06db5d$var$bind(el, value, result, modifiers));
        }));
};
$aa1f5cc61f06db5d$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$aa1f5cc61f06db5d$var$directive("bind", $aa1f5cc61f06db5d$var$handler2);
function $aa1f5cc61f06db5d$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$aa1f5cc61f06db5d$var$addRootSelector(()=>`[${$aa1f5cc61f06db5d$var$prefix("data")}]`);
$aa1f5cc61f06db5d$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($aa1f5cc61f06db5d$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $aa1f5cc61f06db5d$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $aa1f5cc61f06db5d$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $aa1f5cc61f06db5d$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $aa1f5cc61f06db5d$var$injectMagics(data2, el);
    let reactiveData = $aa1f5cc61f06db5d$var$reactive(data2);
    $aa1f5cc61f06db5d$var$initInterceptors2(reactiveData);
    let undo = $aa1f5cc61f06db5d$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $aa1f5cc61f06db5d$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $aa1f5cc61f06db5d$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$aa1f5cc61f06db5d$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $aa1f5cc61f06db5d$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$aa1f5cc61f06db5d$var$isCloning) return false;
    if ($aa1f5cc61f06db5d$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$aa1f5cc61f06db5d$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $aa1f5cc61f06db5d$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $aa1f5cc61f06db5d$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$aa1f5cc61f06db5d$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $aa1f5cc61f06db5d$var$parseForExpression(expression);
    let evaluateItems = $aa1f5cc61f06db5d$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $aa1f5cc61f06db5d$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$aa1f5cc61f06db5d$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $aa1f5cc61f06db5d$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($aa1f5cc61f06db5d$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $aa1f5cc61f06db5d$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $aa1f5cc61f06db5d$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($aa1f5cc61f06db5d$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $aa1f5cc61f06db5d$var$mutateDom(()=>{
                if (!elForSpot) $aa1f5cc61f06db5d$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $aa1f5cc61f06db5d$var$reactive(scope2);
            $aa1f5cc61f06db5d$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $aa1f5cc61f06db5d$var$mutateDom(()=>{
                lastEl.after(clone2);
                $aa1f5cc61f06db5d$var$initTree(clone2);
            });
            if (typeof key === "object") $aa1f5cc61f06db5d$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $aa1f5cc61f06db5d$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $aa1f5cc61f06db5d$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $aa1f5cc61f06db5d$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $aa1f5cc61f06db5d$var$handler3() {}
$aa1f5cc61f06db5d$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $aa1f5cc61f06db5d$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$aa1f5cc61f06db5d$var$directive("ref", $aa1f5cc61f06db5d$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$aa1f5cc61f06db5d$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $aa1f5cc61f06db5d$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $aa1f5cc61f06db5d$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $aa1f5cc61f06db5d$var$addScopeToNode(clone2, {}, el);
        $aa1f5cc61f06db5d$var$mutateDom(()=>{
            el.after(clone2);
            $aa1f5cc61f06db5d$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $aa1f5cc61f06db5d$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($aa1f5cc61f06db5d$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$aa1f5cc61f06db5d$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$aa1f5cc61f06db5d$var$setIdRoot(el, name));
});
$aa1f5cc61f06db5d$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$aa1f5cc61f06db5d$var$mapAttributes($aa1f5cc61f06db5d$var$startingWith("@", $aa1f5cc61f06db5d$var$into($aa1f5cc61f06db5d$var$prefix("on:"))));
$aa1f5cc61f06db5d$var$directive("on", $aa1f5cc61f06db5d$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $aa1f5cc61f06db5d$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $aa1f5cc61f06db5d$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$aa1f5cc61f06db5d$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$aa1f5cc61f06db5d$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$aa1f5cc61f06db5d$var$warnMissingPluginDirective("Focus", "trap", "focus");
$aa1f5cc61f06db5d$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $aa1f5cc61f06db5d$var$warnMissingPluginDirective(name, directiveName, slug) {
    $aa1f5cc61f06db5d$var$directive(directiveName, (el)=>$aa1f5cc61f06db5d$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$aa1f5cc61f06db5d$var$alpine_default.setEvaluator($aa1f5cc61f06db5d$var$normalEvaluator);
$aa1f5cc61f06db5d$var$alpine_default.setReactivityEngine({
    reactive: $aa1f5cc61f06db5d$var$reactive2,
    effect: $aa1f5cc61f06db5d$var$effect2,
    release: $aa1f5cc61f06db5d$var$stop,
    raw: $aa1f5cc61f06db5d$var$toRaw
});
var $aa1f5cc61f06db5d$export$b7ee041e4ad2afec = $aa1f5cc61f06db5d$var$alpine_default;
// packages/alpinejs/builds/module.js
var $aa1f5cc61f06db5d$export$2e2bcd8739ae039 = $aa1f5cc61f06db5d$export$b7ee041e4ad2afec;

});

parcelRegister("fdBqT", function(module, exports) {

var $9j4uS = parcelRequire("9j4uS");
module.exports = $9j4uS("hUp9w").then(()=>parcelRequire("5nIl8"));

});
parcelRegister("9j4uS", function(module, exports) {
"use strict";

function $6c6960696d09a0b1$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("fsC6G")).resolve(id));
}
module.exports = $6c6960696d09a0b1$var$load;

});



var $eByBq = parcelRequire("eByBq");
// packages/persist/src/index.js
function $1d49dee12a45eb7e$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $1d49dee12a45eb7e$var$storageHas(lookup, storage) ? $1d49dee12a45eb7e$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $1d49dee12a45eb7e$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $1d49dee12a45eb7e$var$storageHas(key, storage) ? $1d49dee12a45eb7e$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $1d49dee12a45eb7e$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $1d49dee12a45eb7e$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $1d49dee12a45eb7e$var$storageGet(key, storage) {
    return JSON.parse(storage.getItem(key, storage));
}
function $1d49dee12a45eb7e$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $1d49dee12a45eb7e$export$2e2bcd8739ae039 = $1d49dee12a45eb7e$export$9a6132153fba2e0;


(0, $eByBq.default).plugin((0, $1d49dee12a45eb7e$export$2e2bcd8739ae039));
window.Alpine = (0, $eByBq.default);
(0, $eByBq.default).store("settingsModal", {
    show: false,
    developmentMode: false,
    enableDevTools: (0, $eByBq.default).$persist(false).as("enableDevTools"),
    requireAllHintsUsed: (0, $eByBq.default).$persist(false).as("requireAllHintsUsed")
});

// must come after the settings modal store (because I can't figure out how to make typescript play nice with $persist)
(parcelRequire("fdBqT")).then(()=>{
    (0, $eByBq.default).start();
});


//# sourceMappingURL=index.56d8f76a.js.map
